import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { FormObjectService } from "../../core/FieldObject";
import { SearchBank } from "../../model/backoffice/bank";
import { AlertError } from "../../core/Helper";
import {
  GetReceiptPaymentObject,
  PaymentMethod,
} from "../../core/BillingRecieptComponent";
import { GetEditorForm } from "../../core/Helper2";
import SearchBigData, { DefaultState } from "../components/SearchBigData";
import SearchTypeB from "../components/SearchTypeB";
import FormAutoObject from "../../core/FormAutoObject";

export default function PaymentEditor(props) {
  const userInfo = useSelector((state) => state.user.detail);
  const [objField, setObjField] = useState([]);
  const [form, setForm] = useState(null);
  const [editor, setEditor] = props.editor;
  const [searchB, setSearchB] = useState(DefaultState);
  const [searchBig, setSearchBig] = useState(DefaultState);
  const refForm1 = useRef();
  const dispatch = useDispatch();
  const [data, setData] = useState({});

  useEffect(() => {
    if (editor?.show) {
      buildForm();
      if (editor?.idValue > 0) {
        //   getOldData();
      }

      if (editor?.data) {
        setData(editor.data);
      }

      return () => {
        clearObject();
      };
    }
  }, [editor?.show]);

  const clearObject = () => {
    setData([]);
    setForm(null);
    setObjField(null);
    setSearchBig(null);
    setSearchB(null);
  };

  const bankClick = (item) => {
    SearchBank([setSearchBig, data, setData, userInfo, item]);
  };

  const buildForm = async () => {
    let obj = await GetReceiptPaymentObject({
      bankClick,
      data,
    });
    setObjField(await FormObjectService.BuildsFormOBJs(obj));
  };

  useEffect(() => {
    if (editor?.show) {
      buildForm();
    }
  }, [data]);

  useEffect(() => {
    if (editor?.show) {
      renderForm();
    }
  }, [objField]);

  /** Render form */
  const renderForm = async () => {
    setForm(
      <FormAutoObject
        {...{ items: objField, dataValue: [data, setData], refTo: refForm1 }}
      />
    );
  };

  const actionSave = async () => {
    let payMethodId = Number(data?.PayMethod?.PayMethodId);

    if (payMethodId < 1) {
      AlertError("กรุณาเลือกประเภทการจ่าย", dispatch);
      return;
    }
    if (Number(data?.Amount) < 1) {
      AlertError("กรุณาระบุจำนวนเงิน", dispatch);
      return;
    }
    if (payMethodId > 1) {
      let suffixText = PaymentMethod[Number(payMethodId)]?.suffix;
      if (!data?.ChqNo) {
        AlertError("กรุณาระบุเลขที่" + suffixText, dispatch);
        return;
      }
      if (data?.ChqBank?.BankId < 1) {
        AlertError("กรุณาเลือกธนาคาร", dispatch);
        return;
      }
    }

    editor.action(data);
    //   }
  };

  return (
    <>
      <GetEditorForm
        {...{
          title: "ระบุวิธีการจ่าย",
          form: [form, setForm],
          editor: [editor, setEditor],
          saveData: actionSave,
        }}
      />
      <SearchTypeB {...{ winState: [searchB, setSearchB] }} />
      <SearchBigData {...{ winState: [searchBig, setSearchBig] }} />
    </>
  );
}
